<template>
  <span v-if="showErrorMessage" v-html="errorMessage" class="text-sm text-focus-error"/>
</template>

<script>
export default {
  name: 'InputErrorMessage',

  props: {
    errorMessage: {
      type: String,
      default: ''
    },
    showErrorMessage: {
      type: Boolean,
      default: false
    }
  }
}
</script>
